import styles from "./PermissionsModal.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import {SetStateAction, useCallback, useState} from "react";
import {useComponentVisible} from "../../../hooks/useComponentVisible";
import {useMachine} from "@xstate/react";
import {FetchMachine} from "../../machines/FetchMachine";
import {debounce} from "../../../utils/CleversiteUtilities";
import NotificationManager from "../../notifications/NotificationManager";
import WatsonApi from "../../../backends/WatsonApi";
import {useStores} from "../../../stores/useStores";

interface SearchResult {
    id: string,
    title: string,
}

export function PermissionDropdown(props: {
    displayName: string | number | readonly string[] | undefined,
    resultId: string | null,
    setDisplayName: SetStateAction<any>,
    setResultId: SetStateAction<any> | null,
    provider: "google" | "office365",
    lookupType: string,
}) {
    const {organizationStore} = useStores();
    const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
    const {ref, isComponentVisible, setIsComponentVisible} = useComponentVisible();
    const [groupSearchCurrent, sendGroupSearch] = useMachine(FetchMachine);
    const lookupType = props.lookupType
    const handleSearchValueChange = useCallback(debounce(async value=> {
        sendGroupSearch("FETCH");
        if (!value) {
            props.setDisplayName('');
            props.setResultId([]);
            sendGroupSearch("FULFILL");
            return
        }
        try {
            let results = []
            if (lookupType === 'group')
            {
                const client = await WatsonApi()
                const response = await client.apis.organizations.organizations_permissions_search_permissions_groups({
                    organization_pk: organizationStore.currentOrganization.id,
                    value: value,
                })
                results=JSON.parse(response.data)
            }
            else if (lookupType === "user"){
                const client = await WatsonApi()
                const response = await client.apis.organizations.organizations_permissions_search_permissions_users({
                    organization_pk: organizationStore.currentOrganization.id,
                    value: value,
                })
                results=JSON.parse(response.data)
            }
            sendGroupSearch("FULFILL");
            setIsComponentVisible(true);
            setSearchResults(results as SearchResult[])
        } catch (e) {
            console.log(e)
            NotificationManager.error('Internal server error. Try again later.');
            sendGroupSearch("REJECT");
        }
    }, 250) as (value: string) => void, [])

    function handleResultClick(result) {
        props.setDisplayName(result.title);
        props.setResultId([result.id]);
        setIsComponentVisible(false);
    }

    let dropdown;
    if (searchResults.length > 0) {
        dropdown = <ul key={"hasresults"}>
            {searchResults.map(result => <li key={result.id} role={"button"} onClick={e => {
                handleResultClick(result)
            }}>{result.title}</li>)}
        </ul>
    } else if (props.displayName && groupSearchCurrent.value !== "PENDING" && isComponentVisible) {
        dropdown = <ul key={"noresults"}>
            <li>No Results</li>
        </ul>
    }

    // @ts-ignore
    return <div ref={ref} className={styles.dropdownContainer}>
        <div>
            <input
                id="sb-search-groups"
                className="sb-search-groups form-control"
                placeholder={lookupType==='group'?"Enter group or OU name":"Enter Email Address"}
                value={props.displayName}
                onChange={e => {
                    props.setDisplayName(e.target.value);
                    handleSearchValueChange(e.target.value);
                }}
            />
            {groupSearchCurrent.value === "PENDING" &&
                <FontAwesome className={"sb-loading-icon"} prefix={'fas'} spin name="fa-spinner"/>}
        </div>
        {isComponentVisible && <div>
            {dropdown}
        </div>}
    </div>
}
